/**
 * Campaign cover art with an optional progress overlay, ported from the
 * creator-portal prototype (ROU-1192). Presentational only.
 */

type Accent = 'sky';

type Size = 'card' | 'featured' | 'detail';

type Props = {
    accent?: Accent;
    size?: Size;
    progress?: number;
    src?: string | null;
    alt?: string;
};

const CampaignArtwork = ({ accent = 'sky', size = 'card', progress, src = null, alt = 'Campaign artwork' }: Props) => {
    return (
        <div className={`campaign-art campaign-art--${accent} campaign-art--${size}`}>
            {src && <img src={src} alt={alt} />}
            {typeof progress === 'number' && (
                <span className="campaign-art__progress">
                    <b style={{ width: `${progress}%` }} />
                </span>
            )}
        </div>
    );
};

export default CampaignArtwork;
